import{styled as t}from"@mui/material/styles";import o from"@mui/material/Button";const e=t(o)((({ownerState:{loading:t,buttonWidth:o,isMobileScreen:e}})=>({...t&&{pointerEvents:"none",cursor:"default",...!e&&o&&{width:`${o}px}`}}})));export{e as Button};
//# sourceMappingURL=styles.js.map
